module.exports = __webpack_public_path__ + "img/3A等级证书_05.8262970b.jpg";